import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'

import {Button, Item, List, Image} from 'semantic-ui-react'

import { logout, showAuth0Lock } from '../../../auth'

import UserQuery from '../../../graphql/queries/user.graphql'

@graphql(UserQuery, { options: { fetchPolicy: 'network-only' }})
export default class User extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  render() {
    return (
      <div>
        {this._renderUser()}
      </div>
    )
  }

  // <Button onClick={logout}>
  //  Logout
  // </Button>

  _renderUser() {
    const {loading, user} = this.props.data;

    if (loading) {
      return this._renderLoading();
    }

    if (!user) {
      return this._renderLogin();
    }

    return (
      <List horizontal style = {{marginTop: 2}}>
        <List.Item>
          {user.name}
          <Image avatar
            src={user.avatarUrl}
            alt={user.name}
            style={{ height: 40, width: 40, borderRadius: 20, marginLeft: 15 }} />
        </List.Item>
      </List>

    )
  }

  _renderLoading() {
    return (
      <div>...</div>
    )
  }

  _renderLogin() {
    return (
      <Button onClick={showAuth0Lock}>
        Login
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/container/user/index.js